import { config } from "@repo/config";
import { createNavigation } from "next-intl/navigation";
import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
	locales: Object.keys(config.i18n.locales),
	defaultLocale: config.i18n.defaultLocale,
	localeCookie: {
		name: config.i18n.localeCookieName,
	},
	localePrefix: config.i18n.enabled ? "always" : "never",
	localeDetection: config.i18n.enabled,
	// No `Link` response header. next-intl derives it from the URL alone, so it
	// advertised a `de` alternate on English-only pages and its own x-default on
	// the homepage, contradicting the hreflang each page declares in its
	// metadata. Pages own their alternates (see generatePageMetadata).
	alternateLinks: false,
});

export const {
	Link: LocaleLink,
	redirect: localeRedirect,
	usePathname: useLocalePathname,
	useRouter: useLocaleRouter,
} = createNavigation(routing);
